import { Component, EventEmitter, HostListener, Inject, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { FormBuilder, Validators, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { MatStepper } from "@angular/material/stepper";
import { FontsService } from "../../../services/fonts.service";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { FONTS } from "shared-library";
import { SharedService } from "ngx-mobile-app";
import { VlDataService, VlHttpService, HTTPAPIConfig, APIConfigMapping,ImageCropperComponent } from "shared-library";
import { Subject, takeUntil } from "rxjs";


@Component({
  selector: "app-project-type",
  templateUrl: "./project-type.component.html",
  styleUrls: ["./project-type.component.scss"],
})
export class ProjectTypeComponent implements OnInit,OnDestroy {
  @Output() dataChanged: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('stepper') stepper!: MatStepper;
  imageSrc = '';
  isExistedAppName: boolean = false;
  selectedOption: number = this.selectedApptype.appType;
  appThemeGroup!: FormGroup;
  postAppDetailsData!: FormGroup;
  postFontData!: FormGroup;
  fontStyles: any[] = [];
  selectedFontFamily: string = this.fontService.selectedFont;
  fontFamily: string = "";
  fontUri: string = "";
  applicatioLogo!: File;
  defaultAppLolo: File | undefined;
  isDefaultAppLogo: boolean = true;
  primaryColor: string = "#FF5733";
  secondaryColor: string = "#1256FF";
  textColor: string = "#000000";
  backgroundColor: string = "#EFEFEF";
  isThemesSelected: boolean = false;
  globalThemesData: any[] = [];
  colors: any[] = [];
  themes: any[] = [];
  types: any[] = [];
  themeId: any = "";
  spinnerVisible:boolean=false;
  isApplicationName: boolean = false;
  isHeadingFont: boolean = true;
  isBodyFont: boolean = true;
  showImageLengthError:boolean =false;
  appNameMinLength:boolean = false;
  isCheckingAppName:boolean = false;
  showImageTypeError:boolean =false;
  private destroy$ = new Subject<void>();
  
  constructor(
    private router: Router,
    private _formBuilder: FormBuilder,
    private dialogref: MatDialogRef<ProjectTypeComponent>,
    private fontService: FontsService,
    private dataService: VlDataService,
    private httpService: VlHttpService,
    private sharedService :SharedService,
    private dialog:MatDialog,
    @Inject(MAT_DIALOG_DATA) public selectedApptype: any
  ) {}

  // (keydown.escape)="cancelButtonClicked()" (keydown.enter)="next(stepper)"

  @HostListener('window:keyup.esc') onKeyUp() {
    this.dialogref.close();
  }
  @HostListener('window:keyup.enter') onEnterUp() {
    this.next(this.stepper);
  }

  getApplicationTypes() {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(
      APIConfigMapping[""]
    );
    apiConfig.postData = {};

    this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$)).subscribe({
      next: (data: any) => {},
      error: (err: any) => {},
    });
  }

  ngOnInit(): void {
    const projectDataString = localStorage.getItem('ProjectMetaData');
    if (projectDataString) {
      const projectData = JSON.parse(projectDataString);
      this.imageSrc = projectData.image;
      if (this.isDefaultAppLogo && typeof this.imageSrc === 'string' && this.imageSrc.includes('mobiwise.s3')) {
        this.getDefaultAppLogo(this.imageSrc);
      }else{
       this.assignBlobToFile(projectData.image,'defaultAppLogo.png');
      }
    }
    this.googleFont();
    this.formbuilder();
    this.postAppDetailsData.patchValue({'appIcon':true})
  }

  googleFont() {
    this.types = FONTS
  }

  changeFontStyle(event: any) {
    this.selectedFontFamily = event.target.value;
    this.update();
  }

  private fontLinkElement: HTMLLinkElement | null = null;
  update() {
    this.fontFamily = this.selectedFontFamily;
    this.fontUri = `https://fonts.googleapis.com/css2?family=${this.fontFamily.replace(
      " ",
      "+"
    )}&display=swap`;
    let pos = this.fontFamily.indexOf(":");
    if (pos > 0) {
      this.fontFamily = this.fontFamily.substring(0, pos);
    }
    // let link = document.getElementById("myfontlink");
   // Safer link management
  if (!this.fontLinkElement) {
    this.fontLinkElement = document.createElement("link");
    this.fontLinkElement.id = "myfontlink";
    this.fontLinkElement.setAttribute("rel", "stylesheet");
    document.head.appendChild(this.fontLinkElement);
  }
    this.selectAll();
  }

  selectAll() {
    let textFontFamily = <HTMLInputElement>(
      document.getElementById("textFontFamily")
    );
    textFontFamily.select();
  }

  formbuilder() {
    this.appThemeGroup = this._formBuilder.group({
      primaryColor: "#0061A6",
      secondaryColor: "#6C5778",
      defaultBackgroundColor: "#FAF9FD",
      defaultTextColor: "#45474A",
      theme: "",
    });

    this.postAppDetailsData = this._formBuilder.group({
      applicationName: ["", [Validators.required, Validators.minLength(3)]],
      applicationDescription: [
        "",
        [Validators.maxLength(80)],
      ],
      biometrics:[false],
      appIcon:[false,Validators.required]
    });

    this.postFontData = this._formBuilder.group({
      headingFont: ["", Validators.required],
      bodyFont: ["", Validators.required],
    });
  }

  getColorValue(controlName: string) {
    return this.appThemeGroup.get(controlName)?.value || "#000000";
  }

  NavigateToWebProject() {
    this.router.navigate(["/web"]);
  }

  NavigateToMobileProject() {
    this.router.navigate(["/mobile"]);
  }

  changeAppName(event:any){
    this.isApplicationName = false;
    this.isExistedAppName = false;
    this.sharedService.setStepperIndexValue(false);

    if(event.target.value.length >= 3){
      this.isCheckingAppName = true;
      this.checkAppName(event.target.value).pipe(takeUntil(this.destroy$)).subscribe((data) => {
        this.isExistedAppName = data;
        this.isCheckingAppName = false;
      },(error) => {
        this.isExistedAppName = true;
        this.isCheckingAppName = false;
      })
      this.appNameMinLength = false;
    }
  }

  checkAppName(pageName: string) {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['CHECK_APPLICATION_NAME']);
    apiConfig.postData = {application_name: pageName}
   return this.httpService.placeAPICall(apiConfig);
  }

  isHeadingFontSelected(){
    return this.postFontData.get('headingFont')?.valid;
  }
  
  isBodyFontSelected(){
    return this.postFontData.get('bodyFont')?.valid;
  }

  async next(stepper: MatStepper) {
    if (stepper.selectedIndex == 0) {
      if(this.postAppDetailsData.get('applicationName')?.value == '' || this.postAppDetailsData.get('applicationName')?.value == null){
         this.isApplicationName = true;
      }
      if(this.selectedApptype.existedApplicationName.includes(this.postAppDetailsData.get('applicationName')?.value)){
        this.isExistedAppName = true;
      }
      if (this.postAppDetailsData.valid && !this.isExistedAppName) {
        stepper.next();
        const apiConfig: HTTPAPIConfig = this.dataService.deepClone(
          APIConfigMapping["GET_THEMES"]
        );
        await this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$)).subscribe({
          next: (data: any) => {
            this.fontStyles = data;
            this.appThemeGroup.patchValue({theme:data[data.length-1]})
            if(data?.length !=0){
              this.onOptionSelected({value:data[data.length-1]})
            }
          },
          error: (err: any) => {},
        });
      } 
    } else if (stepper.selectedIndex == 1) {    
      if (!this.postFontData.invalid && !this.appThemeGroup.invalid) {
        let colorValues: any = {};
        if (
          this.appThemeGroup.getRawValue()?.theme == "" ||
          this.appThemeGroup.getRawValue()?.theme == "Custom Theme"
        ) {
          colorValues.primary_color = this.appThemeGroup.getRawValue().primaryColor;
          colorValues.secondary_color = this.appThemeGroup.getRawValue().secondaryColor;
          colorValues.background_color = this.appThemeGroup.getRawValue().defaultBackgroundColor;
          colorValues.text_color = this.appThemeGroup.getRawValue().defaultTextColor;
          colorValues.theme = this.appThemeGroup.getRawValue().theme;
        } else {
          colorValues.primary_color =
            this.appThemeGroup.getRawValue().theme?.primary_color;
          colorValues.secondary_color =
            this.appThemeGroup.getRawValue().theme?.secondary_color;
          colorValues.background_color =
            this.appThemeGroup.getRawValue().theme?.background_color;
          colorValues.text_color =
            this.appThemeGroup.getRawValue().theme?.text_color;
          colorValues.theme = this.appThemeGroup.getRawValue().theme?.theme_name;
        }
        const appDetailsDataValues = this.postAppDetailsData.value;
        const fontDataValues = this.postFontData.value;
        const applicationType = this.selectedOption == 1 ? "Web" : "Mobile";
        const apiConfig: HTTPAPIConfig = this.dataService.deepClone(
          APIConfigMapping["CREATE_THEME"]
        );
        let userDetails:any=JSON.parse(localStorage.getItem("userInfo") || '');
        apiConfig.postData = {
          theme_name: colorValues?.theme,
          primary_color: colorValues.primary_color,
          secondary_color: colorValues.secondary_color,
          background_color: colorValues.background_color,
          text_color: colorValues.text_color,
          font_heading: this.postFontData.getRawValue()?.headingFont,
          font_body: this.postFontData.getRawValue()?.bodyFont,
          created_by: userDetails?.userId,
          last_modified_by: userDetails?.userId,
        };
        this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$)).subscribe({
          next: async (data: any) => {
            this.spinnerVisible=true;
            this.themeId = data.theme_id;
            const icon: File | undefined = this.isDefaultAppLogo ? this.defaultAppLolo : this.applicatioLogo ;
            const navigationHelper = this.selectedOption;
            const formData = {
              applicationType,
              ...colorValues,
              ...appDetailsDataValues,
              icon,
              ...fontDataValues,
              navigationHelper,
              theme_id: this.themeId,
              primaryColor:colorValues.primary_color
            };
            this.spinnerVisible=false;
            this.dataChanged.emit(formData);
          },
          error: (err: any) => {
            this.spinnerVisible=false;
          },
        });
      }
    }
  }

  selectorOption(option: number) {
    this.selectedOption = option;
  }

  onOptionSelected(selectedFontStyle: any) {
    this.postFontData.reset();
    if (selectedFontStyle.value === "Custom Theme") {
      this.isThemesSelected = false;
      this.googleFont();
    } else {
      this.isThemesSelected = true;
      this.primaryColor = selectedFontStyle.value.primary_color;
      this.secondaryColor = selectedFontStyle.value.secondary_color;
      this.textColor = selectedFontStyle.value.text_color;
      this.backgroundColor = selectedFontStyle.value.background_color;
      this.types = [];
      this.types.push({
        font_heading: selectedFontStyle?.value?.font_heading,
        font_body: selectedFontStyle?.value?.font_body,
      });
      this.postFontData.patchValue({
        headingFont: selectedFontStyle?.value?.font_heading,
        bodyFont: selectedFontStyle?.value?.font_body,
      });
    }
  }

  onFileSelected(event: any) {
    const selectedFile = event.target.files[0];
    if (!selectedFile?.type.startsWith('image/')) {
      this.showImageTypeError = true;
      return;
    }
    if (selectedFile) {
      if (this.applicatioLogo) {
        this.applicatioLogo = null as any;
      }
      this.showImageTypeError = false;
      this.isDefaultAppLogo = false;
      this.applicatioLogo = selectedFile;

      this.openCropper(selectedFile);
    }
  }

  openCropper(selectedimage:File){
    const dialogRef =  this.dialog.open(ImageCropperComponent,{
       disableClose: true,
       data: {
        imageFile:selectedimage
      }
    })

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {

      if (typeof (result) !== 'boolean' && result !== undefined) {
        
        this.imageSrc = result.croppedImageUrl,
        this.applicatioLogo = result.croppedImageFile
       
      }
    });
  }

  getDefaultAppLogo(image?:any): Promise<File> {
    const defaultAppLogoUrl = image ?? this.imageSrc;
    return fetch(defaultAppLogoUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error(`Failed to fetch image: ${response.statusText}`);
        }
        return response.blob();
      })
      .then(blob => {
        this.defaultAppLolo = new File([blob], 'defaultAppLogo.png', {
          type: 'image/png',
          lastModified: Date.now()
        });
        return this.defaultAppLolo;
      });
  }

 async assignBlobToFile(safeUrl: any, fileName: string, mimeType = 'image/png') {
    const blobUrl = (safeUrl as any).changingThisBreaksApplicationSecurity || safeUrl;

    try {
        const response = await fetch(blobUrl);
        if (!response.ok) throw new Error(`Failed to fetch blob: ${response.status}`);
        const blob = await response.blob();
        const file = new File([blob], fileName, { type: mimeType });
        this.defaultAppLolo = file;
    } catch (err) {
        console.error('Error converting SafeUrl to File:', err);
        this.defaultAppLolo = undefined;
    }
}

  cancelButtonClicked(){
    this.sharedService.setStepperIndexValue(false);
    if (this.imageSrc && this.imageSrc.startsWith('blob:')) {
      URL.revokeObjectURL(this.imageSrc);
    }
    this.dialogref.close();
  }

  isNextDisabled(index:number): boolean {
    if (index === 0) {
      return this.postAppDetailsData.get('applicationName')?.invalid || this.isExistedAppName || this.isCheckingAppName || this.showImageTypeError;
    } else{
      return this.postFontData.invalid;
    }
  }

  ngOnDestroy(): void {
    const link = document.getElementById("myfontlink");
    if (link) {
        document.head.removeChild(link);
    }

    // Clear file references to help GC
    this.applicatioLogo = null as any;
    this.defaultAppLolo = undefined;
    
    // Clear image src URL if it's a blob URL
    if (this.imageSrc && this.imageSrc.startsWith('blob:')) {
      URL.revokeObjectURL(this.imageSrc);
    }

    // clearing the variables which may hold refrences to large objects
    this.fontStyles = [];
    this.globalThemesData = [];
    this.colors = [];
    this.themes = [];
    this.types = [];

    this.destroy$.next();
    this.destroy$.complete();
  }

}
